import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  activeTab: null,
  activeTabList: 'Top Gainers',
  displayedCards: [],
  symbolTokens: [],
  selectedItem: null,
  loading: false,
  error: null,
  marketData: {},
  marketDataOld: {},
};

const marketSlice = createSlice({
  name: 'market',
  initialState,
  reducers: {
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
    setActiveTabList: (state, action) => {
      state.activeTabList = action.payload;
    },
    fetchSymbolTokensRequest: (state) => {
      state.loading = true;
      state.error = null;
    },

    fetchSymbolTokensSuccess: (state, action) => {
      state.loading = false;
      state.symbolTokens = action.payload.tokens;
      // Store market data by tab
      if (action.payload.tab && action.payload.data) {
        state.marketDataOld[action.payload.tab] = action.payload.data;
      }
    },

    fetchSymbolTokensFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchMarketDataRequest: (state) => {
      state.loading = true;
      state.error = null;
    },

    fetchMarketDataSuccess: (state, action) => {
      state.loading = false;
      state.displayedCards = action.payload;
    },
    fetchMarketDataFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    setSelectedItem: (state, action) => {
      // debugger;
      state.selectedItem = action.payload;
    },
    clearSelectedItem: (state) => {
      state.selectedItem = null;
    },
    updateMarketData: (state, action) => {
      state.displayedCards = action.payload;
    },

    clearMarketData: (state) => {
      state.marketData = {};
      state.selectedItem = null;
      state.displayedCards = [];
      state.symbolTokens = [];
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  setActiveTab,
  setActiveTabList,
  fetchSymbolTokensRequest,
  fetchSymbolTokensSuccess,
  fetchSymbolTokensFailure,
  fetchMarketDataRequest,
  fetchMarketDataSuccess,
  fetchMarketDataFailure,
  setSelectedItem,
  clearSelectedItem,
  updateMarketData,
  clearMarketData,
} = marketSlice.actions;

export default marketSlice.reducer;